import React from 'react';
import _reduce from 'lodash/reduce';
import _isFunction from 'lodash/isFunction';
import _isEmpty from 'lodash/isEmpty';
import _noop from 'lodash/noop';

import { StatefulPopover, PLACEMENT } from 'baseui/popover';
import { Overflow } from 'baseui/icon';
import { StatefulMenu } from 'baseui/menu';
import { useStyletron } from 'baseui';

interface IAction {
	name: any;
	isEnabled: (rowData: any) => boolean;
}

interface IModifiedAction {
	label: any;
	onClick: any;
}

interface ISingleRowActionProps {
	rowActions: IAction[];
	rowData: any;
	getActionHandler: any;
	setForceUpdateRows: (value: boolean) => void;
	setConfirmationDialog: React.Dispatch<
		React.SetStateAction<{
			show: boolean;
			header?: string | undefined;
		}>
	>;
}
const SingleRowAction: React.FC<ISingleRowActionProps> = (props) => {
	const { rowActions, rowData, getActionHandler, ...params } = props;

	const [css] = useStyletron();

	const modifiedRowActions = _reduce(
		rowActions,
		(acc, action) => {
			const actionHandler = getActionHandler(action, { rowData, ...params });
			if (_isFunction(action.isEnabled) && action.isEnabled(rowData)) {
				acc.push({
					label: action.name,
					onClick: _isFunction(actionHandler) ? actionHandler : _noop
				});
			}
			return acc;
		},
		[] as IModifiedAction[]
	);

	const handleItemSelect = ({ item }: { item: any }) => {
		item.onClick();
	};

	if (_isEmpty(modifiedRowActions)) {
		return <></>;
	}

	return (
		<StatefulPopover
			content={<StatefulMenu items={modifiedRowActions} onItemSelect={handleItemSelect} />}
			placement={PLACEMENT.right}
			accessibilityType='tooltip'>
			<div
				className={css({
					':hover': {
						cursor: 'pointer'
					}
				})}>
				<Overflow size={20} />
			</div>
		</StatefulPopover>
	);
};

export default SingleRowAction;
